export default class ErrorHandler {

    constructor(errorModal) {
        this.errorModal = errorModal;
    }

    init() {
        const self = this;
        try {
            if (Bugsnag) {
                self.bugsnag = Bugsnag;
                if (self.bugsnag) {
                    self.bugsnag.start({apiKey: BUGSNUGAPIKEY, appVersion: APP_VERSION});
                }
            }
        } catch (e) {

        }
    }

    handleErrorNotifyAdminAndUser(userMessage, e) {
        try {
            const self = this;
            console.error(e);
            self.errorModal.show(userMessage);
            if (self.bugsnag) {
                self.bugsnag.notify(e);
            }
        } catch (e) {
        }
    }

    handleErrorNotifyUser(userMessage) {
        try {
            const self = this;
            self.errorModal.show(userMessage);
        } catch (e) {
        }
    }

    handleAdminError(e) {
        try {
            const self = this;
            if (self.bugsnag) {
                self.bugsnag.notify(e);
            }
        } catch (e) {
        }
    }

    showModal(content) {
        const self = this;
        this.errorModal.show(content);
    }

}